import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';

const ContentCardWrapper = styled.div`
  justify-self: baseline;
  /* margin-top: 1rem; */
  padding: 20px 0 4px 0px;
  width: inherit;
  position: relative;

  @media ${breakpointsMinWidth.tabletSm} {
    padding: 16px 0 4px 0px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 20px 0 4px 0px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    padding: 22px 0 4px 0px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 20px 0 4px 0px;
  }
`;

const ContentCard = ({ children }) => (
  <ContentCardWrapper>{children}</ContentCardWrapper>
);

ContentCard.propTypes = {
  children: propTypes.node.isRequired,
};

export default ContentCard;
